import type { EmbeddedIframeSandbox } from '@/types/embeddedApplication';

export function buildIframeSandboxAttribute(
  sandbox: EmbeddedIframeSandbox = {},
): string | undefined {
  const tokens: string[] = [];

  if (sandbox.allowSameOrigin) {
    tokens.push('allow-same-origin');
  }

  if (sandbox.allowScripts) {
    tokens.push('allow-scripts');
  }

  if (sandbox.allowForms) {
    tokens.push('allow-forms');
  }

  if (sandbox.allowPopups) {
    tokens.push('allow-popups');
  }

  if (sandbox.additionalTokens?.length) {
    tokens.push(...sandbox.additionalTokens);
  }

  return tokens.length > 0 ? tokens.join(' ') : undefined;
}
